import React, { Component } from "react";
import { Link, NavLink, withRouter } from "react-router-dom";
import "./LeftMenu.css";

class LeftMenu extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: props.data.hasOwnProperty("left_menu") ? props.data.left_menu : [],
			// openedItem: false
		};
	}

	// componentDidMount() {
	// 	if (document.querySelector(".left_menu_items .active") && document.querySelector(".left_menu_items .active").classList[0]){
	// 		const opened = document.querySelector(".left_menu_items .active").classList[0];
	// 		document.querySelectorAll(`.left_menu_items .${opened}`).forEach(function (e) {
	// 			e.classList.add("opened")
	// 		})
	// 		console.log("Mounted: ", opened);
	// 	}
	// }

	render() {

		// console.log("LeftMenu props: ", this.props.data);
		//console.log("LeftMenu state: ", this.state);

		// const toggleOpen = e => {
		// 	document.querySelectorAll(`.left_menu_items .${e.currentTarget.classList[0]}`).forEach(function (e) {
		// 		e.classList.toggle("opened")
		// 	})
		// }

		const active = this.props.data.selected_third_menu_id ? this.props.data.selected_third_menu_id : "";

		let parentIndex;

		return (
			<div className="LeftMenu">
				<ul className="left_menu_items">
					{this.state.data.map(function (item, index) {
						if (!item.submenu) {
							parentIndex = item.id;
						}
						const isActive = active - 1 == index ? "active" : "";
						const isSubMenu = item.submenu ? "sub-item" : "main-item";
						// const isOpened = parentIndex == active - 1 ? "opened" : "";
						const elementOf = `element-of-${parentIndex}`;
						const moveRight = item.move_right ? "move" : "";

						return (
							item.url ? (
								<li className={`${elementOf} ${isActive} ${isSubMenu} ${moveRight}`} key={index}>
									<a href={item.url}>
										{item.name}
									</a>
								</li>
							) : (
									<li className={`${elementOf} ${isActive} ${isSubMenu} ${moveRight}`} key={index}>
										{item.name}
									</li>
								)

						)
					})}
				</ul>
			</div>
		);
	}
}

export default withRouter(LeftMenu);



// WEBPACK FOOTER //
// ./src/Components/Elements/LeftMenu/LeftMenu.js